import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';
import styles from '../index.styl';
import { DESCRIPTION_MAX_SYMBOLS } from '../../../../constants/styles';
import ReadMoreBtn from '../../../common/ReadMoreBtn';

const Description = ({ text }) => {
  const [shortened, setShortened] = useState(true);

  const isTooLong = text.length > DESCRIPTION_MAX_SYMBOLS;

  const textTransform = string => {
    return string.slice(0, DESCRIPTION_MAX_SYMBOLS).replace(/([^ ]*)$/, '');
  };

  const rootText = shortened && isTooLong ? textTransform(text) : text;

  const handleClick = () => {
    setShortened(!shortened);
  };

  return (
    <div styleName="description">
      <div styleName="description__text">
        <p>{rootText}</p>
      </div>

      <If condition={shortened && isTooLong}>
        <div styleName="description__button">
          <ReadMoreBtn onClick={handleClick} />
        </div>
      </If>
    </div>
  );
};

Description.propTypes = {
  text: PropTypes.string.isRequired,
};

export default compose(CSSModules(styles, { allowMultiple: true }))(
  Description,
);



// WEBPACK FOOTER //
// ./src/components/Community/About/Description/index.jsx